export default __webpack_public_path__ + "static/media/investor relation.aceffef3.jpg";